import { viewerTimeZone } from 'src/contexts/identityAndTenancy';
import { toCalendarDate } from 'src/kernel/time';

/**
 * Today as the person looking at the screen reads it: the calendar date in their zone.
 *
 * The context's one clock read. Only the composable or component deciding what "today" means for a
 * screen calls it; every rule beneath takes the date as `asOf`.
 *
 * @returns {string} 'YYYY-MM-DD'
 */
// eslint-disable-next-line import/prefer-default-export
export const viewerToday = () => toCalendarDate(new Date(), viewerTimeZone());
